import styled from 'styled-components';

const WorkPatternStyles = styled.div`
  padding: 0 35px;

  .wp-header {
    width: 800px;
    padding: 0 10px 10px;
    height: 32px;

    .actions {
      margin-left: 10px;
    }
  }

  .current-week {
    margin-right: 10px;
  }

  .weeks {
    margin-right: 50px;
    position: relative;
    overflow: hidden;
    flex-shrink: 0;

    .week {
      position: absolute;
      left: 0;
      top: 0;
      z-index: 1;

      &.selected {
        position: relative;
        z-index: 2;
      }
    }
  }

  .right-side {
    width: 500px;
  }
`;

export default WorkPatternStyles;
